export function restrictScroll() {
  document.body.style.overflow = 'hidden';
}

export function unleashScroll() {
  document.body.style.overflow = '';
}
